'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var PropTypes = _interopDefault(require('prop-types'));

var React = require('react');

var React__default = _interopDefault(React);

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var castArray = function castArray(value) {
  return Array.isArray(value) ? value : [value];
};

var useOuterClick = function useOuterClick(refs) {
  var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (process.env.NODE_ENV !== 'production' && typeof handler !== 'function') {
    throw new TypeError("Expected \"handler\" to be a function, not ".concat(_typeof(handler), "."));
  }

  var refsRef = React.useRef(refs);
  var handerRef = React.useRef(handler);
  React.useEffect(function () {
    refsRef.current = refs;
    handerRef.current = handler;
  }, [refs, handler]);
  React.useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (castArray(refsRef.current).every(function (ref) {
        return ref.current && ref.current !== event.target && !ref.current.contains(event.target);
      })) {
        handerRef.current(event);
      }
    };

    document.addEventListener('mousedown', handleClickOutside, true);
    document.addEventListener('touchstart', handleClickOutside, true);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside, true);
      document.removeEventListener('touchstart', handleClickOutside, true);
    };
  }, []);
};

var OuterClick = function OuterClick(props) {
  var children = props.children,
      onOuterClick = props.onOuterClick,
      restProps = _objectWithoutProperties(props, ["children", "onOuterClick"]);

  var ref = React.useRef();
  useOuterClick(ref, onOuterClick);
  return React__default.createElement("div", _extends({}, restProps, {
    ref: ref
  }), children);
};

OuterClick.propTypes = {
  children: PropTypes.element.isRequired,
  onOuterClick: PropTypes.func.isRequired
};
exports.OuterClick = OuterClick;
exports.default = OuterClick;
exports.useOuterClick = useOuterClick;